<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [(update)]="updateFlag"
  [oneToOne]="oneToOneFlag"
  style="width: 100%; height: 100%; display: block"
></highcharts-chart>
